import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import HomePage from '../Pages/Home';
import AboutPage from '../Pages/About';
import ServicesPage from '../Pages/Services';
import PortfolioPage from '../Pages/Portfolio';
import ProjectDetails from '../Pages/ProjectDetails';
import ContactPage from '../Pages/Contact';
import BlogPage from '../Pages/Blog';
import BlogDetails from '../Pages/BlogDetails';
import AdminDashboard from '../Pages/AdminDashboard';
import AdminBlogList from '../Pages/AdminBlogList';
import AdminBlogEdit from '../Pages/AdminBlogEdit';
import AdminPortfolioList from '../Pages/AdminPortfolioList';
import AdminPortfolioEdit from '../Pages/AdminPortfolioEdit';
import AdminBlogCategories from '../Pages/AdminBlogCategories';
import AdminPortfolioCategories from '../Pages/AdminPortfolioCategories';
import AdminOffers from '../Pages/AdminOffers';
import AdminResources from '../Pages/AdminResources';
import AdminLogs from '../Pages/AdminLogs';
import LoginPage from '../Pages/LoginPage';
import ProfilePage from '../Pages/ProfilePage';
import SupportTickets from '../Pages/SupportTickets';
import SupportTicketCreate from '../Pages/SupportTicketCreate';
import AdminTickets from '../Pages/AdminTickets';
import AdminTicketDetail from '../Pages/AdminTicketDetail';
import AdminUsers from '../Pages/AdminUsers';
import AdminUserAdd from '../Pages/AdminUserAdd';
import AdminUserDetail from '../Pages/AdminUserDetail';
import AdminAnalytics from '../Pages/AdminAnalytics';
import AdminCategories from '../Pages/AdminCategories';
import AdminMessages from '../Pages/AdminMessages';
import MyProjects from '../Pages/MyProjects';
import TicketDetail from '../Pages/TicketDetail';
import PrivacyPolicy from '../Pages/PrivacyPolicy';
import TermsConditions from '../Pages/TermsConditions';
import SupportPage from '../Pages/Support';
import AdminNewsletters from '../Pages/AdminNewsletters';
import AuditPage from '../Pages/AuditPage';
import AdminAuditList from '../Pages/AdminAuditList';
import AdminAuditDetail from '../Pages/AdminAuditDetail';
import ServiceWebDevelopment from '../Pages/ServiceWebDevelopment';
import ServiceMobileApps from '../Pages/ServiceMobileApps';
import ServiceInfrastructure from '../Pages/ServiceInfrastructure';
import ServicePartnership from '../Pages/ServicePartnership';
import IndustryPersonal from '../Pages/IndustryPersonal';
import IndustryBusiness from '../Pages/IndustryBusiness';
import IndustryGov from '../Pages/IndustryGov';
import IndustryLearning from '../Pages/IndustryLearning';
import IndustryAI from '../Pages/IndustryAI';
import IndustriesPage from '../Pages/IndustriesPage';
import FAQPage from '../Pages/FAQPage';
import PartnerBecome from '../Pages/PartnerBecome';
import PartnerDashboard from '../Pages/PartnerDashboard';
import PartnerMaterials from '../Pages/PartnerMaterials';
import PartnerOffers from '../Pages/PartnerOffers';
import NotFoundPage from '../Pages/NotFoundPage';
import AdminMunicipalities from '../Pages/AdminMunicipalities';
import AdminMunicipalityDetail from '../Pages/AdminMunicipalityDetail';
import AdminMunicipalityAnalytics from '../Pages/AdminMunicipalityAnalytics';
import AdminMunicipalityReport from '../Pages/AdminMunicipalityReport';
import AdminProducts from '../Pages/AdminProducts';
import AdminProductEdit from '../Pages/AdminProductEdit';
import ProductsPage from '../Pages/ProductsPage';
import ProductDetails from '../Pages/ProductDetails';
import AdminPotentialCustomers from '../Pages/AdminPotentialCustomers';
import AdminPotentialCustomerDetail from '../Pages/AdminPotentialCustomerDetail';
import AdminPotentialCustomerCreate from '../Pages/AdminPotentialCustomerCreate';
import AdminDemoRequests from '../Pages/AdminDemoRequests';

import ProtectedRoute from '../../components/ProtectedRoute';
import CookieConsent from '../../components/CookieConsent';



import { HelmetProvider } from 'react-helmet-async';

const ScrollToTop = () => {
    const { pathname } = useLocation();
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

const AllRoute = () => {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Default route - redirect to English home */}
            <Route path="/" element={<Navigate to="/en" replace />} />
            
            {/* Language-specific routes */}
            <Route path="/:lang" element={<HomePage />} />
            <Route path="/:lang/about" element={<AboutPage />} />
            <Route path="/:lang/services" element={<ServicesPage />} />
            <Route path="/:lang/services/web-development" element={<ServiceWebDevelopment />} />
            <Route path="/:lang/services/mobile-apps" element={<ServiceMobileApps />} />
            <Route path="/:lang/services/infrastructure" element={<ServiceInfrastructure />} />
            <Route path="/:lang/services/partnership" element={<ServicePartnership />} />
            <Route path="/:lang/portfolio" element={<PortfolioPage />} />
            <Route path="/:lang/portfolio/:key" element={<ProjectDetails />} />
            <Route path="/:lang/products" element={<ProductsPage />} />
            <Route path="/products" element={<Navigate to="/en/products" replace />} />
            <Route path="/:lang/products/:slug" element={<ProductDetails />} />
            <Route path="/products/:slug" element={<ProductDetails />} />
            <Route path="/:lang/blog" element={<BlogPage />} />
            <Route path="/:lang/blog/:id" element={<BlogDetails />} />
            <Route path="/:lang/contact" element={<ContactPage />} />
            <Route path="/:lang/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/:lang/terms-conditions" element={<TermsConditions />} />
            <Route path="/:lang/support" element={<ProtectedRoute><SupportPage /></ProtectedRoute>} />
            <Route path="/:lang/faq" element={<FAQPage />} />
            <Route path="/:lang/audit" element={<AuditPage />} />
            <Route path="/audit" element={<AuditPage />} />
            <Route path="/:lang/industries" element={<IndustriesPage />} />
            <Route path="/:lang/industries/personal" element={<IndustryPersonal />} />
            <Route path="/:lang/industries/business" element={<IndustryBusiness />} />
            <Route path="/:lang/industries/gov" element={<IndustryGov />} />
            <Route path="/:lang/industries/learning" element={<IndustryLearning />} />
            <Route path="/:lang/industries/ai" element={<IndustryAI />} />

            {/* Partner routes - public */}
            <Route path="/:lang/partners/become" element={<PartnerBecome />} />

            {/* Partner routes - protected */}
            <Route path="/:lang/partner/dashboard" element={<ProtectedRoute><PartnerDashboard /></ProtectedRoute>} />
            <Route path="/:lang/partner/materials" element={<ProtectedRoute><PartnerMaterials /></ProtectedRoute>} />
            <Route path="/:lang/partner/offers" element={<ProtectedRoute><PartnerOffers /></ProtectedRoute>} />

            {/* Login routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/:lang/login" element={<LoginPage />} />

            {/* Admin routes */}

            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/:lang/admin" element={<AdminDashboard />} />
            <Route path="/admin/blogs" element={<AdminBlogList />} />
            <Route path="/:lang/admin/blogs" element={<AdminBlogList />} />
            <Route path="/admin/blogs/new" element={<AdminBlogEdit />} />
            <Route path="/:lang/admin/blogs/new" element={<AdminBlogEdit />} />
            <Route path="/admin/blogs/edit/:id" element={<AdminBlogEdit />} />
            <Route path="/:lang/admin/blogs/edit/:id" element={<AdminBlogEdit />} />
            <Route path="/admin/blog-categories" element={<AdminBlogCategories />} />
            <Route path="/:lang/admin/blog-categories" element={<AdminBlogCategories />} />
            <Route path="/admin/portfolio" element={<AdminPortfolioList />} />
            <Route path="/:lang/admin/portfolio" element={<AdminPortfolioList />} />
            <Route path="/admin/portfolio/new" element={<AdminPortfolioEdit />} />
            <Route path="/:lang/admin/portfolio/new" element={<AdminPortfolioEdit />} />
            <Route path="/admin/portfolio/edit/:id" element={<AdminPortfolioEdit />} />
            <Route path="/:lang/admin/portfolio/edit/:id" element={<AdminPortfolioEdit />} />
            <Route path="/admin/portfolio-categories" element={<AdminPortfolioCategories />} />
            <Route path="/:lang/admin/portfolio-categories" element={<AdminPortfolioCategories />} />
            <Route path="/admin/offers" element={<AdminOffers />} />
            <Route path="/:lang/admin/offers" element={<AdminOffers />} />
            <Route path="/admin/products" element={<AdminProducts />} />
            <Route path="/:lang/admin/products" element={<AdminProducts />} />
            <Route path="/admin/products/add" element={<AdminProductEdit />} />
            <Route path="/:lang/admin/products/add" element={<AdminProductEdit />} />
            <Route path="/admin/products/new" element={<AdminProductEdit />} />
            <Route path="/:lang/admin/products/new" element={<AdminProductEdit />} />
            <Route path="/admin/products/edit/:id" element={<AdminProductEdit />} />
            <Route path="/:lang/admin/products/edit/:id" element={<AdminProductEdit />} />
            <Route path="/admin/resources" element={<AdminResources />} />
            <Route path="/:lang/admin/resources" element={<AdminResources />} />
            <Route path="/admin/municipalities" element={<AdminMunicipalities />} />
            <Route path="/:lang/admin/municipalities" element={<AdminMunicipalities />} />
            <Route path="/admin/municipalities/analytics" element={<AdminMunicipalityAnalytics />} />
            <Route path="/:lang/admin/municipalities/analytics" element={<AdminMunicipalityAnalytics />} />
            <Route path="/admin/municipalities/report" element={<AdminMunicipalityReport />} />
            <Route path="/:lang/admin/municipalities/report" element={<AdminMunicipalityReport />} />
            <Route path="/admin/municipalities/:id" element={<AdminMunicipalityDetail />} />
            <Route path="/:lang/admin/municipalities/:id" element={<AdminMunicipalityDetail />} />
            <Route path="/admin/potential-customers" element={<AdminPotentialCustomers />} />
            <Route path="/:lang/admin/potential-customers" element={<AdminPotentialCustomers />} />
            <Route path="/admin/potential-customers/new" element={<AdminPotentialCustomerCreate />} />
            <Route path="/:lang/admin/potential-customers/new" element={<AdminPotentialCustomerCreate />} />
            <Route path="/admin/potential-customers/:id" element={<AdminPotentialCustomerDetail />} />
            <Route path="/:lang/admin/potential-customers/:id" element={<AdminPotentialCustomerDetail />} />
            <Route path="/admin/logs" element={<AdminLogs />} />
            <Route path="/:lang/admin/logs" element={<AdminLogs />} />
            <Route path="/admin/tickets" element={<AdminTickets />} />
            <Route path="/:lang/admin/tickets" element={<AdminTickets />} />
            <Route path="/admin/tickets/detail/:id" element={<AdminTicketDetail />} />
            <Route path="/:lang/admin/tickets/detail/:id" element={<AdminTicketDetail />} />
            <Route path="/admin/tickets/:id" element={<AdminTicketDetail />} />
            <Route path="/:lang/admin/tickets/:id" element={<AdminTicketDetail />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/:lang/admin/users" element={<AdminUsers />} />
            <Route path="/admin/users/add" element={<AdminUserAdd />} />
            <Route path="/:lang/admin/users/add" element={<AdminUserAdd />} />
            <Route path="/admin/users/detail/:id" element={<AdminUserDetail />} />
            <Route path="/:lang/admin/users/detail/:id" element={<AdminUserDetail />} />
            <Route path="/admin/analytics" element={<AdminAnalytics />} />
            <Route path="/:lang/admin/analytics" element={<AdminAnalytics />} />
            <Route path="/admin/categories" element={<AdminCategories />} />
            <Route path="/:lang/admin/categories" element={<AdminCategories />} />
            <Route path="/admin/messages" element={<AdminMessages />} />
            <Route path="/:lang/admin/messages" element={<AdminMessages />} />
            <Route path="/admin/demo-requests" element={<AdminDemoRequests />} />
            <Route path="/:lang/admin/demo-requests" element={<AdminDemoRequests />} />
            <Route path="/admin/newsletters" element={<AdminNewsletters />} />
            <Route path="/:lang/admin/newsletters" element={<AdminNewsletters />} />
            <Route path="/admin/audits" element={<AdminAuditList />} />
            <Route path="/:lang/admin/audits" element={<AdminAuditList />} />
            <Route path="/admin/audits/:id" element={<AdminAuditDetail />} />
            <Route path="/:lang/admin/audits/:id" element={<AdminAuditDetail />} />
            <Route path="/admin/audits/detail/:id" element={<AdminAuditDetail />} />
            <Route path="/:lang/admin/audits/detail/:id" element={<AdminAuditDetail />} />

            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/my-projects" element={<MyProjects />} />
            <Route path="/support" element={<ProtectedRoute><SupportTickets /></ProtectedRoute>} />
            <Route path="/support/create" element={<ProtectedRoute><SupportTicketCreate /></ProtectedRoute>} />
            <Route path="/support/ticket/:id" element={<ProtectedRoute><TicketDetail /></ProtectedRoute>} />

            <Route path="/:lang/404" element={<NotFoundPage />} />
            <Route path="/404" element={<NotFoundPage />} />
            {/* Catch-all 404 */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <CookieConsent />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
};

export default AllRoute;